export default __webpack_public_path__ + "static/media/remove.fe39b04f.svg";